import React from 'react'
import { Link } from 'react-router-dom'
import { iComponent } from '../../utilities/ImageImports'

const PlayTitle = ({
  title = '',
  subtitle = '',
  linkTo = '',
  capsule = false,
  titleIcon=iComponent
}) => {
  return (
    <Link
      to={linkTo}
      className={`
        hover:bg-emerald-200 p-4 rounded-lg shadow-lg flex flex-col items-start space-y-1 dark:bg-cDarkBG2 bg-slate-100 text-gray-800 dark:text-cDarkText transition-all ease-out duration-100
        ${capsule ? "w-full" : "w-[200px]"}
      `}
    >
      <div className='flex items-center space-x-2 w-full' >
        <img src={titleIcon} alt="" className='w-[15px] h-[15px] ' />
        <div className='sm:text-xl text-lg font-semibold capitalize max-w-full truncate' title={title} >{title}</div>
      </div>
      <div className='sm:text-sm text-xs font-light dark:text-cDarkText text-gray-700 max-w-full truncate' title={subtitle}>{subtitle}</div>
    </Link>
  )
}

export default PlayTitle